import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Prompt} from 'react-router-dom';
import Modal from './modal';
import {clearUnsavedChanges} from '../common-redux/common.actions';
import {setConfirmHandler} from '../util/nav-confirm';

// App-level guard: blocks navigation while there are unsaved changes and shows
// the "Unsaved Changes" confirmation modal listing the changed fields.
// Rendered once (in app.js); pages opt in by dispatching setUnsavedChanges /
// clearUnsavedChanges.
export class UnsavedChangesGuard extends Component {
  constructor(props) {
    super(props);
    this.state = {open: false, cb: null, fields: []};
  }

  componentDidMount() {
    // react-router calls getUserConfirmation -> this handler when a <Prompt> blocks.
    // Snapshot the changed fields at open time so a later store clear can't blank the list.
    setConfirmHandler((message, callback) =>
      this.setState({open: true, cb: callback, fields: this.props.changedFields}));
  }

  componentDidUpdate(prevProps) {
    // Native browser dialog for tab-close / refresh (text is not customizable).
    if (prevProps.hasUnsavedChanges !== this.props.hasUnsavedChanges) {
      window.onbeforeunload = this.props.hasUnsavedChanges ?
        (e) => {
          e.preventDefault(); e.returnValue = ''; return '';
        } :
        null;
    }
  }

  componentWillUnmount() {
    setConfirmHandler(null);
    window.onbeforeunload = null;
  }

  finish = (allow) => {
    const {cb} = this.state;
    this.setState({open: false, cb: null, fields: []}, () => {
      if (cb) cb(allow);
    });
  };

  handleCancel = () => this.finish(false);

  handleConfirm = () => {
    this.props.clearUnsavedChanges();
    this.finish(true);
  };

  renderContent() {
    const {fields} = this.state;
    return (
      <div className="session-warning-dialog">
        <div className="dialog-alert">
          You have unsaved changes. If you continue without saving, all changes will be lost.
        </div>
        {fields && fields.length > 0 && (
          <div className="dialog-changes">
            <p className="dialog-message">The following changes will be discarded:</p>
            <ul>
              {fields.map((field, i) => <li key={i}>{field}</li>)}
            </ul>
          </div>
        )}
      </div>
    );
  }

  render() {
    return (
      <>
        <Prompt when={this.props.hasUnsavedChanges} message="unsaved-changes" />
        <Modal
          open={this.state.open}
          title="Unsaved Changes"
          content={this.renderContent()}
          primaryButton="Continue Without Saving"
          secondaryButton="Cancel"
          close={this.handleCancel}
          confirm={this.handleConfirm}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const common = state.commonReducer || {};
  return {
    hasUnsavedChanges: !!common.hasUnsavedChanges,
    changedFields: common.changedFields || [],
  };
};

export default connect(mapStateToProps, {clearUnsavedChanges})(UnsavedChangesGuard);
